<template>
  <div>
    <div class="BottomMenuBox">
      <div class="BottomMenu">
        <ul >
          <li v-for="item in dataList" :key="item.ID">
            <a
              v-if="item.Url.indexOf('http') != -1"
              :href="item.Url"
              target="_blank"
              >{{ item.Title  }}</a
            >
            <router-link
              v-else
              :to="item.Url"
              :key="CId"
              > {{ item.Title }}</router-link
            >
          </li>
          <!-- <li><a href="./index.html">首页</a></li>
                  <li><a href="./list.html">党建动态</a></li>
                  <li><a href="./howllow">通知公告</a></li>
                  <li><a href="./howllow">重要文件</a></li>
                  <li><a href="./index.html">精准扶贫</a></li>
                  <li><a href="./index.html">统战工作</a></li>
                  <li><a href="./index.html">先进风采</a></li>-->
          <!--<li><a href="http://www.tianyi.edu.cn/"  target="_blank">学院首页</a></li>-->
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BottomMenu",
  props:{
  dataList:{
    type: Array,
    default:()=>[]
  }
  },
  data() {
    return {
      CId: this.$route.query.CId,
    };
  },
  methods: {
   
  },
  created() {
 
    //  console.log(this.menuListOne)
  },
};
</script>
<style lang="less" scoped>
.BottomMenuBox{
  width: 6.9rem;
  margin: 0 auto;
  border-top: 0.02rem dashed  #C5C5C5;
   ul{
     width: 7.4rem;
     position: relative;
     margin: 0 auto;
     display: flex;
     margin-left:-0.2rem;
     align-content: center;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
     li{
       background: #F3F3F3;
       padding: 0.1rem 0 ;
       width: 1.425rem;
       margin:0 0.2rem;
       margin-top: 0.25rem;
       border-radius: 0.05rem ;
       a{
          // border-right: 1px solid rgba(0, 0, 0, 0.349) ;
          text-align: center;
          display: block;
         font-size: 0.2rem;
         line-height: 0.26rem;
         color: #666666;
         letter-spacing: 0.01rem;
         padding: 0 .1rem;
       }
     }
   }
}


</style>


// WEBPACK FOOTER //
// src/components/bottomMenu.vue